import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from 'src/lib/utils';
import { feedbackDs } from './feedback-ds-classes';

interface FeedbackDsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}

export function FeedbackDsModal({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
  bodyClassName,
}: FeedbackDsModalProps) {
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className={feedbackDs.overlay} />
        <DialogPrimitive.Content
          className={cn(feedbackDs.modal, className)}
          onClick={(event) => event.stopPropagation()}
        >
          <div className={feedbackDs.header}>
            <div className="min-w-0 pr-8">
              <DialogPrimitive.Title className={feedbackDs.title}>
                {title}
              </DialogPrimitive.Title>
              {description ? (
                <DialogPrimitive.Description className={feedbackDs.description}>
                  {description}
                </DialogPrimitive.Description>
              ) : null}
            </div>
            <DialogPrimitive.Close
              className="absolute right-5 top-5 rounded-md p-0.5 text-[#9CA3AF] transition-colors hover:text-[#0D0F1A] focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(37,99,235,0.20)]"
              onClick={(event) => event.stopPropagation()}
            >
              <X
                className="size-[18px]"
                aria-hidden
              />
              <span className="sr-only">
                Close
              </span>
            </DialogPrimitive.Close>
          </div>

          <div className={cn(feedbackDs.body, bodyClassName)}>
            {children}
          </div>

          {footer ? (
            <div className={feedbackDs.footer}>
              {footer}
            </div>
          ) : null}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

interface FeedbackDsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'secondary' | 'accent';
}

export function FeedbackDsButton({
  variant = 'secondary',
  className,
  type = 'button',
  ...props
}: FeedbackDsButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        feedbackDs.btnBase,
        variant === 'accent' ? feedbackDs.btnAccent : feedbackDs.btnSecondary,
        className
      )}
      {...props}
    />
  );
}
